export default function Origin() {
  return (
    <section className="py-24 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* 왼쪽 이미지 */}
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/ef87dbbb0dafe1672307b26c89accecf.jpg"
              alt="가평 화악산의 청정 자연"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-4 -right-4 w-48 h-48 bg-[#6B4E9C]/10 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* 오른쪽 텍스트 */}
          <div className="space-y-8">
            <div className="inline-block bg-[#6B4E9C]/10 text-[#6B4E9C] px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
              첫 번째 기준
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              원료의 정직함
            </h2>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                모든 것은 가평 화악산의 깨끗한 자연에서 시작됩니다.
              </p>
              <p>
                포도가 자라는 환경이 포도 본연의 맛과 향을 결정합니다.
              </p>
              <p className="font-semibold text-gray-900">
                자연 그대로, 약품을 살포하지 않습니다.
              </p>
              <p>
                원료의 힘을 흐리는 요소를 배제합니다.<br />
                포도 본연의 맛과 향을 지키는 첫 번째 원칙입니다.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full flex-shrink-0">
                  <i className="ri-leaf-line text-2xl text-[#6B4E9C]"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">천연 유기 퇴비 재배</h4>
                  <p className="text-gray-600">
                    땅의 힘을 믿습니다. 오직 천연 유기 퇴비로만 키웁니다. 자연의 순리를 따르는 재배가 포도 스스로 깊고 진한 맛을 쌓게 합니다. 이것이 억지스럽지 않은 단맛의 바탕이 됩니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
